import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import ReactQuill from 'react-quill';
import Constant from '../../Constant';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import {
	getAllProductParts,
	AddParts,
	updatePart,
	getSingleProductPart,
} from '../../actions/homeAction';
import { useState } from 'react';
import { useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';

const AddSparePart = () => {

	const config = {
		headers: {
		  'Content-Type': 'application/json',
		  Authorization: localStorage.getItem('loged_In_auth'),
		},
	};

	const [sparePart, setSparePart] = useState({
		name:'',
		nameAr:'',
		status: true,
		products:''
	})
	const [products, setProducts] = useState([])
	const [selectedProducts, setSelectedProducts] = useState([])
	const [image, setImage] = useState({})
	const [mediaID, setMediaID] = useState('')

	const {spUUID} = useParams()

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getAllProductParts())
		dispatch(getSingleProductPart(spUUID))
	},[])

	const allproductparts = useSelector(state => state.home.ProductList)?.response
	const singleProductPart = useSelector(state => state.home.singleProductPart)?.response?.[0]

	useEffect(() => {
		setSparePart({
			name:singleProductPart?.name,
			nameAr:singleProductPart?.nameAr,
			status: singleProductPart?.status,
			products:singleProductPart?.name
		})
		const filteredProducts = singleProductPart?.partProducts?.map(data => {
			return {
				value: data.partId,
				label: data?.product?.name
			}
		})
		setImage(singleProductPart?.medium?.path)
		setMediaID(singleProductPart?.mediaId)
		// console.log("filteredProducts",filteredProducts);
		
		setSelectedProducts(filteredProducts)
		setProducts(filteredProducts)
	},[singleProductPart])

	const handleChange = e => {
		const {name, value} = e.target;
		setSparePart({...sparePart, [name]:value})
	}

	const onProductChange = (values) => {
		
		setProducts(values)
		setSelectedProducts(values)
		console.log("values", values);
	}
	

	const uploadMedia = (e) => {
		console.log("media", e.target.files[0]);
		const file = e.target.files[0]
	
		const reader = new FileReader(file)
		reader.readAsDataURL(file);
		// console.log("result", reader);
		if(file !== undefined){
		  reader.onloadend = () => {
			  setImage({
				mimeType: reader.result
			  })
			  console.log("result", image);
		  }
		}
		let data = new FormData()
	
		data.append('media', file)
		console.log("datadata", data);
	
		axios
		  .post('https://caravenue.infoware.xyz/api/media/new', data, config)
	
		  .then(res => {
			console.log("responsehtisis", res.data.response.media[0]?.mediaId);
			setImage(res.data.response.media[0])
			setMediaID(res.data.response.media[0]?.mediaId)
		  })
		  .catch(err => {
			console.log(err);
		  })
	  }
	
	const onSave = () => {
		var productsID = []
		products.forEach(dt => productsID.push(dt.value))
		const payload = {
			name: sparePart?.name,
			nameAr: sparePart?.nameAr,
			status: sparePart?.status,
			products: productsID,
			mediaId: mediaID
		}

		if(spUUID){
			console.log("UPDATE",payload);
			const payload2 = {
				name: sparePart?.name,
				nameAr: sparePart?.nameAr,
				status: sparePart?.status,
				// products: productsID,
				mediaId: mediaID
			}
			dispatch(updatePart({...payload2,partId:spUUID}))
		}else{
			dispatch(AddParts(payload))
		}
		
		// alert('ADDED')
	}

	const [prodOption, setProdOption] = useState([])

useEffect(() => {
	const value = []
	allproductparts?.forEach(element => {
		let option = {
			value: element.productId,
			label: element.name
		}
		value.push(option)
	})
	setProdOption(value)
},[allproductparts])

console.log("sparePart", singleProductPart);
// console.log("prodOption", prodOption);
const customStyles = {
	control: styles => ({
	  ...styles,
	  boxShadow: "none",
	  outline: "none",
	  border: "1px solid rgba(221,221,221)",
	  "&:hover": { border: "1px solid rgba(22,87,79)" },
	  cursor: "text",
	  padding: "0.25rem",
	  paddingLeft: "0.25rem",
	}),
  
	option: styles => ({
	  ...styles,
	  marginLeft: "0.25rem",
	  marginRight: "0.25rem",
	  borderRadius: "0.25rem",
	  cursor: "pointer",
	  width: "98%",
	}),
  
	multiValue: styles => ({
	  ...styles,
	  fontSize: "0.91rem",
	  marginRight: "0.5rem",
	  padding: "0.125rem 0.25rem 0.125rem 0.625rem",
	  backgroundColor: "white",
	  border: "1px solid #55595C",
	  borderRadius: "9999px",
	  color: "#1a202c",
	}),
  
	multiValueRemove: styles => ({
	  ...styles,
	  cursor: "pointer",
	  color: "black",
	  opacity: "0.6",
	  ":hover": { background: "transparent" },
	  svg: { width: "16px", height: "16px" },
	}),
  
	indicatorSeparator: () => ({ display: "none" }),
  
	dropdownIndicator: styles => ({
	  ...styles,
	  svg: {
		width: "16px",
		height: "16px",
		fill: "black",
		opacity: "0.5",
	  },
	}),
  };
		return (
			// sjfhsdakjf
			<div className=''>
				<div className='col-md-6'>
					<div className='form-group row'>
						<h1>Add Spare Part</h1>

						<div className='col-sm-9'></div>
					</div>
				</div>

				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Spare Part Name (En)
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='name'
										id=' VehicleType'
										placeholder=' Spare Part Name (En)'
										onChange={handleChange}
										value={sparePart.name}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>
									Spare Part Name (Ar)
								</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='nameAr'
										id=' VehicleType'
										placeholder=' Spare Part Name (Ar)'
										onChange={handleChange}
										value={sparePart.nameAr}
									/>
								</div>
							</div>
						</div>

						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>products</label>
								<div className='col-sm-9'>
									<Select value={selectedProducts} options={prodOption} isMulti onChange={onProductChange} closeMenuOnSelect={false} styles={customStyles}/>
									{/* <select
										name='productId'
										id=' products'
										className='form-control'
										value={sparePart.products}
										onChange={handleChange}>
										<option value='' name=''>
											Select Product
										</option>
										{allproductparts !== undefined &&
										allproductparts !== null &&
										allproductparts !== [] &&
										allproductparts.length > 0
											? allproductparts?.map(ite => {
													return (
														<option value={ite.productId} name=''>
															{ite.name}
														</option>
													);
											  })
											: null}
									</select> */}
								</div>
							</div>
						</div>
						{/* <div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>carBrands</label>
								<div className='col-sm-9'>
									<select
										name='carBrands'
										id=' carBrands'
										className='form-control'
										value={carBrands}
										onChange={handleChange}>
										{carbrandList !== undefined &&
										carbrandList !== null &&
										carbrandList !== [] &&
										carbrandList.length > 0
											? carbrandList?.map(ite => {
													return (
														<option value={ite.brandId} name=''>
															{ite.name}
														</option>
													);
											  })
											: null}
									</select>
								</div>
							</div>
						</div> */}
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='status'
										className='form-control'
										value={sparePart.status}
										onChange={handleChange}>
										<option value={true} name='status'>
											Active
										</option>
										<option value={false} name='status'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
                            <div className='row'>
                              <div className='col-sm-3'> Image</div>
                              <div className='col-sm-9'>
                                <form
                                  id='userImage'
                                  name='userImage'
                                  encType='multipart/form-data'
                                  className='text-capitalize'>
                                  <div className='form-group'>
                                    <input
                                      accept='image/*'
                                      onChange={uploadMedia}
                                      id='banner_image'
                                      type='file'
                                      className='form-control'
                                      autoComplete='off'
                                      name='media'
                                      data-toggle='tooltip'
                                      title='Click To Upload Photo'
                                    />
                                    <div id='banner_image_lable' className='pt-2'>
                                      
                                          <img
                                            src={image}
                                            alt=''
                                            className='img-100'
                                            onError={e => {
                                              e.target.src = '';
                                            }}
                                          />
                                        
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                            </div>
					</div>

					<div className='card-footer'>
						<div className='row float-right p-3'>
							{/* {isSaving ? (
								<button className='btn btn-grd-disabled mr-2' disabled>
									Saving...!
								</button>
							) : ( */}
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> Save
							</button>
							{/* )} */}
							<Link
								to='/SparePartMaster/SpareParts'
								className='btn btn-outline-dark'>
								Cancel
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}

export default AddSparePart
// AddSparePart.propsTypes = {
// 	getCarBarand: PropTypes.func.isRequired,
// 	getAllParts: PropTypes.func.isRequired,
// 	getAllProductParts: PropTypes.func.isRequired,
// };

// var mapStateToProps = state => ({
// 	carbrandList: state?.home?.CarBrandList?.response,
// 	allproductparts: state?.home?.ProductList?.response,
// });

// export default connect(mapStateToProps, {
// 	// AddProductParts,
// 	getCarBrand,
// 	// getAllParts,
// 	getAllProductParts,
// 	AddParts,
// })(AddSparePart);
